(function(window, document, $, undefined){
	
$(document).ready(function(){

	var sliderUl = $('.slider-wrapper').children('ul'),
		slides = sliderUl.find('li'),
		slideWidth = $(slides[0]).width(),
		slideLen = slides.length,
		current = 1,
		totalLen = slideLen * slideWidth;
		
	initSlider(5000);

	function nextSlide(){
		if(++current > slideLen){
			current = 1;
		}
	}

	function transition(container, refresh){
		var margin = -( (current-1) * slideWidth);
		
		container.css({
			'margin-left': margin 
		});
	}

	function updateSlider( refresh, isInit ){
		if( ! isInit )
			sliderUl.fadeToggle("slow");
		
		if( refresh != 0 ){
			setTimeout( function(){
				// sliderUl.fadeToggle(refresh);

				nextSlide();

				/* this will loop in infinity */
				sliderUl.fadeToggle("slow", function(){
					transition(sliderUl, refresh);
					updateSlider( refresh );
				});
			
			}, refresh );
		}
	}

	function resizeSlider(){
		slides.width( $('.slider-wrapper').width() );
		slideWidth = $('.slider-wrapper').width();
		totalLen = slideLen * slideWidth;

		var margin = -( (current-1) * slideWidth);
	
		sliderUl.css({
			'margin-left': margin 
		});
	}

	function initSlider( interval ){
		resizeSlider();
		
		$(window).on('resize', function(){
			resizeSlider();
		});

		var refresh = (interval) ? interval : 0;
		updateSlider(refresh, true);
	}

});

})(window, document, jQuery);